<template>
    <div class="International">
        <headers :title="$t('国际业务')" img="International"></headers>
            <el-row :gutter="20">
                <el-col :span="3" :offset="5"><div class="btn InternationalBtn"> <router-link to="/domestic">{{$t('国内业务')}}</router-link></div></el-col>
                <el-col :span="3"><div class="btn domesticBtn"><router-link to="/International">{{$t('国际业务')}}</router-link> </div></el-col>
            </el-row>
            <div class="line"></div>
            <div class="title">{{$t('国际业务')}}</div>
            <el-row>
                <el-col :span="14" :offset="5">
                    <div class="text" v-html="$t('我们的客户遍布于世界30余个国家和地区，主要有<span>欧洲、美洲、东南亚、中东</span>等等，尤其在欧洲市场已垫定了稳定的市场地位。')">
                        
                    </div>
                </el-col>
            </el-row>

            <el-row style="margin-top:2rem;margin-bottom:3rem;">
                <el-col :span="14" :offset="5"><div class="text">
                    {{$t('我们的客户其中有世界500强的知名企业，大多数都是具有较大规模且有知名品牌的生产商和经销商，有些是精通贸易、销售渠道稳定的批发商及进出口商。绝大多数客户与我们有着长期的贸易合作关系。在国际市场，我们的产品也可为客户定制使用他们自己的定牌商标，为更多的工业防护以及零售市场所使用。')}}
                    </div>
                </el-col>
            </el-row>

            <el-row style="margin-top:2rem;">
                <el-col :span="14" :offset="5">
                    <img src="../../public/img/map2.jpg" width="100%" alt="" srcset="">
                </el-col>
            </el-row>
            <Cooperation :data="iconList"></Cooperation>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
import Cooperation from "@/components/Cooperation.vue";
export default {
    data() {
        return {
            iconList:[
                'International1.jpg','International2.jpg','more.png'
            ]
        }
    },
    components:{
      headers,foot,Cooperation
    }
}
</script>
<style lang="less">
.International{
    .btn{
        line-height: 3rem;
        font-size: 0.8rem;
        cursor: pointer;
        white-space:nowrap;
    }
    .domesticBtn a{
        color: #565656;
        text-decoration: none;    
    }
    .InternationalBtn a{
        text-decoration: none;    
        color: #A0A0A0;
    }
    .line{
        height: 1px;
        width: 100%;
        background-color: #BFBFBF;
    }
    .title{
        font-size: 1.6rem;
        text-align: center;
        font-weight: bold;
        color: #747474;
        margin-top: 5rem;
        margin-bottom: 3rem;
    }
    .text{
        text-align: center;
        font-size: 0.75rem;
        color: #737373;
        line-height: 1.4rem;
        span{
            color: #017CA8;
        }
    }
}
</style>
<i18n>
{
  "en": {
    "国内业务":"Domestic Business",
    "国际业务":"International Business",
    "我们的客户遍布于世界30余个国家和地区，主要有<span>欧洲、美洲、东南亚、中东</span>等等，尤其在欧洲市场已垫定了稳定的市场地位。":"Our customers are located in more than 30 countries and regions in the world, mainly in <span> Europe, America, Southeast Asia, Middle East </span>, etc., especially in the European market has established a stable market position.",
    "我们的客户其中有世界500强的知名企业，大多数都是具有较大规模且有知名品牌的生产商和经销商，有些是精通贸易、销售渠道稳定的批发商及进出口商。绝大多数客户与我们有着长期的贸易合作关系。在国际市场，我们的产品也可为客户定制使用他们自己的定牌商标，为更多的工业防护以及零售市场所使用。":"Among our customers are well-known enterprises in the world's top 500, most of them are manufacturers and distributors with large-scale and well-known brands, and some are wholesalers and importers and exporters who are proficient in trade and have stable sales channels. The vast majority of customers have long-term trade cooperation with us. In the international market, our products can also be customized for customers to use their own trademarks for more industrial protection and retail markets."
    
  },
  "zh": {
    "国内业务":"国内业务",
    "国际业务":"国际业务",
    "我们的客户遍布于世界30余个国家和地区，主要有<span>欧洲、美洲、东南亚、中东</span>等等，尤其在欧洲市场已垫定了稳定的市场地位。":"我们的客户遍布于世界30余个国家和地区，主要有<span>欧洲、美洲、东南亚、中东</span>等等，尤其在欧洲市场已垫定了稳定的市场地位。",
    "我们的客户其中有世界500强的知名企业，大多数都是具有较大规模且有知名品牌的生产商和经销商，有些是精通贸易、销售渠道稳定的批发商及进出口商。绝大多数客户与我们有着长期的贸易合作关系。在国际市场，我们的产品也可为客户定制使用他们自己的定牌商标，为更多的工业防护以及零售市场所使用。":"我们的客户其中有世界500强的知名企业，大多数都是具有较大规模且有知名品牌的生产商和经销商，有些是精通贸易、销售渠道稳定的批发商及进出口商。绝大多数客户与我们有着长期的贸易合作关系。在国际市场，我们的产品也可为客户定制使用他们自己的定牌商标，为更多的工业防护以及零售市场所使用。"
    
  }
}
</i18n>

